// extracted by mini-css-extract-plugin
export default {"vehicleList":"vehicle_list_vehicleList__xjLCQ","Mui-focused":"vehicle_list_Mui-focused__QPz0z","label":"vehicle_list_label__xc24Y"};